import ProductPlan from "@/ui/product-plans/ProductPlan";
import parking from "./parking";
import media from "./media";
import retail from "./retail";
import lodging from "./lodging";
import car_rental from "./car_rental";
import i18n from "@/plugins/i18n";

export const ProductPlans: Record<string, ProductPlan> = {
	parking,
	media,
	retail,
	lodging,
	car_rental,
};

export function registerSpecificProductPlanTranslations(productPlan: string) {
	if (ProductPlans[productPlan]) {
		Object.keys(ProductPlans[productPlan].translations).forEach(
			(locale: string) => {
				i18n.global.mergeLocaleMessage(
					locale,
					ProductPlans[productPlan].translations[locale]
				);
			}
		);
	} else {
		console.error(`No ProductPlan defined in FE for ${productPlan}`);
	}
}
